import { MatSnackBarHorizontalPosition } from "@angular/material/snack-bar";

export interface ToastData {
  type: 'success' | 'danger' | 'warning';
  title: string;
  messages?: string;
  duration?: number;
  horizontalPosition?: MatSnackBarHorizontalPosition
}
